import { getFirestore, collection, doc, getDocs, setDoc, deleteDoc, writeBatch } from 'firebase/firestore';
import { app } from './firebase';

const db = app ? getFirestore(app) : null;

// Geometry (and legs, which nests the same coordinate arrays per-leg) contain
// nested arrays Firestore can't store directly → JSON strings.
function serialize(route) {
  const { geometry, legs, ...rest } = route;
  return {
    ...rest,
    geometry: geometry ? JSON.stringify(geometry) : null,
    legs: legs ? JSON.stringify(legs) : null,
  };
}
function deserialize(id, data) {
  let geometry = data.geometry;
  if (typeof geometry === 'string') { try { geometry = JSON.parse(geometry); } catch { geometry = null; } }
  let legs = data.legs;
  if (typeof legs === 'string') { try { legs = JSON.parse(legs); } catch { legs = null; } }
  return { ...data, id, geometry, legs };
}

export async function fetchCloudSavedRoutes(uid) {
  if (!db) return [];
  const snap = await getDocs(collection(db, 'users', uid, 'savedRoutes'));
  return snap.docs.map(d => deserialize(d.id, d.data()));
}

export async function saveCloudRoute(uid, route) {
  if (!db) return;
  await setDoc(doc(db, 'users', uid, 'savedRoutes', String(route.id)), serialize(route));
}

export async function deleteCloudRoute(uid, id) {
  if (!db) return;
  await deleteDoc(doc(db, 'users', uid, 'savedRoutes', String(id)));
}

// Make the cloud collection match `routes` exactly: upsert all + remove deleted.
export async function syncCloudSavedRoutes(uid, routes) {
  if (!db) return;
  const existing = await getDocs(collection(db, 'users', uid, 'savedRoutes'));
  const keep = new Set(routes.map(r => String(r.id)));
  const batch = writeBatch(db);
  for (const r of routes) batch.set(doc(db, 'users', uid, 'savedRoutes', String(r.id)), serialize(r));
  existing.docs.forEach(d => { if (!keep.has(d.id)) batch.delete(d.ref); });
  await batch.commit();
}
